const root = () => document.querySelector('[data-facets-root]');
let controller;
let timer;

function panelState(open) {
  const current = root();
  const panel = current?.querySelector('[data-facets-panel]');
  const overlay = current?.querySelector('[data-facets-overlay]');
  const toggle = current?.querySelector('[data-facets-open]');
  if (!panel) return;
  panel.classList.toggle('is-open', open);
  overlay?.classList.toggle('is-visible', open);
  toggle?.setAttribute('aria-expanded', String(open));
  document.documentElement.classList.toggle('scroll-lock', open && window.matchMedia('(max-width: 989px)').matches);
}

async function render(url, { push = true } = {}) {
  const current = root();
  if (!current) return;
  const sectionId = current.dataset.section;
  const wasOpen = current.querySelector('[data-facets-panel]')?.classList.contains('is-open');
  const focusId = document.activeElement?.id;

  controller?.abort();
  controller = new AbortController();
  current.setAttribute('aria-busy', 'true');

  const fetchUrl = new URL(url, window.location.origin);
  fetchUrl.searchParams.set('section_id', sectionId);

  try {
    const response = await fetch(fetchUrl, { signal: controller.signal });
    if (!response.ok) throw new Error(String(response.status));
    const html = await response.text();
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-facets-root]');
    if (!next) throw new Error('missing');
    current.replaceWith(next);
    if (wasOpen) panelState(true);
    if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
    if (push) window.history.pushState({ facets: true }, '', url);
  } catch (error) {
    if (error.name !== 'AbortError') window.location.assign(url);
  }
}

function formUrl(form) {
  const params = new URLSearchParams();
  for (const [key, value] of new FormData(form)) {
    if (value !== '') params.append(key, value);
  }
  return `${form.getAttribute('action')}?${params}`;
}

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-facets-input]')) return;
  const form = document.getElementById(event.target.getAttribute('form')) || event.target.closest('form');
  if (!form) return;
  clearTimeout(timer);
  timer = setTimeout(() => render(formUrl(form)), event.target.type === 'number' ? 500 : 0);
});

document.addEventListener('submit', (event) => {
  if (!event.target.matches('[data-facets-form]')) return;
  event.preventDefault();
  render(formUrl(event.target)).then(() => panelState(false));
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-facets-link]');
  if (link) {
    event.preventDefault();
    const isPagination = link.closest('.pagination');
    render(link.href).then(() => {
      if (isPagination) root()?.scrollIntoView({ block: 'start' });
    });
    return;
  }
  if (event.target.closest('[data-facets-open]')) panelState(true);
  if (event.target.closest('[data-facets-close]') || event.target.matches('[data-facets-overlay]')) panelState(false);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && root()?.querySelector('[data-facets-panel].is-open')) panelState(false);
});

window.addEventListener('popstate', () => render(window.location.href, { push: false }));
